import type { RespiAllerPrickTestMeasurementsFinalCustomControlData } from '@common/validation/customControls/allergology/respiAllerPrickTestMeasurements/v1/respiAllerPrickTestMeasurementsSchemaV1';
import { useProcessActivityReadContext } from '@frontend/utils';
import { RespiAllerPrickTestMeasurementsContent } from './RespiAllerPrickTestMeasurementsContent';

export function RespiAllerPrickTestMeasurementsRead() {
    const {
        processActivity: { customControlData, status },
    } = useProcessActivityReadContext<RespiAllerPrickTestMeasurementsFinalCustomControlData>();

    return (
        <RespiAllerPrickTestMeasurementsContent
            customControlData={customControlData}
            status={status}
        />
    );
}
